/**
 * Обработчик списка событий
 *
 * @param {string|array} evtName – имя события или массив имен
 */
function handleEventName(evt) {
  const eventsArr = Array.isArray(evt) ? evt : [ evt ];

  return eventsArr;
}

export default handleEventName;
